//@ts-strict-ignore
//Recursively finds all entries of a given key in an object.
//Used by connectedForm to obtain all 'entityMetaData' entries in connected form values, for alert processing.
const findAllByKey = (obj, keyToFind) => {
  if (obj === null) return [];
  return Object.entries(obj).reduce((acc: any[], [key, value]) => {
    if (key === keyToFind) {
      return acc.concat(value);
    }
    return typeof value === 'object' ? acc.concat(findAllByKey(value, keyToFind)) : acc;
  }, []);
};

export default findAllByKey;
